<mat-dialog-content fxLayout="column">
  <p style="font-weight: 600; font-size: 22px; margin-bottom: 16px; text-align: left;">
    Share Information
  </p>
  <p style="font-size: 14px; margin-bottom: 16px; text-align: left;">
    Choose the version you want to share
  </p>
  <div style="text-align: left; margin-bottom: 8px;">
    <button mat-stroked-button color="primary" (click)="onToggleSelectAll()" [disabled]="isLoading">
      {{profileShareFileTable.selected.length === profileShareFileTable.rows.length ? 'Unselect All' : 'Select All' }}
    </button>
  </div>
  <app-primas-table #profileShareFileTable (onRefresh)="refreshData($event)" [resource]="resource.table"
    [columnsTable]="columns" [allowSelectRow]="true" [optionHeight]="'45vh'" [tableAction]="false" >
  </app-primas-table>
</mat-dialog-content>


<div *ngIf="showBottomAction" mat-dialog-actions class="float-right">
  <button mat-button color="primary" (click)="closeDialog()" [disabled]="isLoading">
    Close
  </button>
 <button mat-raised-button color="primary" (click)="onShare()" [disabled]="isLoading"  [nbSpinner]="isLoading"> 
    Save 
  </button>

</div>

<ng-template #fileNameCol let-row="row" let-rowIndex="rowIndex">
  <span>
    {{row?.userUpload | formatFileName }}
  </span>

</ng-template>